<template>
    <q-dialog v-model="showModal">
        <q-card style="width: 500px; max-width: 80vw;">
            <q-card-section class="row items-center">
                <div class="text-h6">Outgoing details</div>
                <q-space />
                <q-btn
                    outline
                    icon="far fa-copy"
                    label="Copy all details"
                    color="primary"
                    v-clipboard="details_text"
                    @success="copied('All Details copied!')"
                    :loading="loading"
                />
            </q-card-section>

            <q-separator/>

            <q-card-section>
                <q-list>
                    <q-item>
                        <q-item-section avatar>
                            <q-icon name="fa fa-hand-holding-usd" size="md" color="primary"/>
                        </q-item-section>

                        <q-item-section v-if="loading">
                            <q-item-label>
                                <q-skeleton type="text"/>
                            </q-item-label>
                            <q-item-label caption>
                                <q-skeleton type="text"/>
                            </q-item-label>
                        </q-item-section>

                        <q-item-section v-else>
                            <q-item-label caption>Payment method:</q-item-label>
                            <q-item-label lines="1" class="text-bold">{{ details.type }}</q-item-label>
                        </q-item-section>
                    </q-item> <!-- Payment Method -->

                    <q-item v-if="details.bank">
                        <q-item-section avatar>
                            <q-btn dense flat size="md" color="primary"
                                   icon="far fa-copy" round
                                   v-clipboard="details.bank"
                                   @success="copied('Bank name is copied!')"
                                   :loading="loading"
                            />
                        </q-item-section>

                        <q-item-section v-if="loading">
                            <q-item-label>
                                <q-skeleton type="text"/>
                            </q-item-label>
                            <q-item-label caption>
                                <q-skeleton type="text"/>
                            </q-item-label>
                        </q-item-section>

                        <q-item-section v-else>
                            <q-item-label caption>Bank:</q-item-label>
                            <q-item-label lines="1" class="text-bold">{{ details.bank }}</q-item-label>
                        </q-item-section>
                    </q-item> <!-- Bank Name -->

                    <q-item>
                        <q-item-section avatar>
                            <q-btn dense flat size="md" color="primary"
                                   icon="far fa-copy" round
                                   v-clipboard="details.recipient_name"
                                   @success="copied('Recipient\'s name is copied!')"
                                   :loading="loading"
                            />
                        </q-item-section>

                        <q-item-section v-if="loading">
                            <q-item-label>
                                <q-skeleton type="text"/>
                            </q-item-label>
                            <q-item-label caption>
                                <q-skeleton type="text"/>
                            </q-item-label>
                        </q-item-section>

                        <q-item-section v-else>
                            <q-item-label caption>Recipient's name:</q-item-label>
                            <q-item-label lines="1" class="text-bold">{{ details.recipient_name }}</q-item-label>
                        </q-item-section>
                    </q-item> <!-- Recipient's Name -->

                    <q-item>
                        <q-item-section avatar>
                            <q-btn dense flat size="md" color="primary"
                                   icon="far fa-copy" round
                                   v-clipboard="details.rate"
                                   @success="copied('Recipient\'s receive amount is copied!')"
                                   :loading="loading"
                                   v-if="details.currency !== 'IRT'"
                            />
                        </q-item-section>

                        <q-item-section v-if="loading">
                            <q-item-label>
                                <q-skeleton type="text"/>
                            </q-item-label>
                            <q-item-label caption>
                                <q-skeleton type="text"/>
                            </q-item-label>
                        </q-item-section>

                        <q-item-section v-else>
                            <q-item-label caption>Recipient's receive amount:</q-item-label>
                            <q-item-label lines="1">
                                <currency-format
                                    class="inline-block text-bold"
                                    :value="details.rate"
                                    :unit="details.currency"
                                    hide-white-spaces
                                    hide-zero-decimal
                                />
                            </q-item-label>
                        </q-item-section>
                    </q-item> <!-- Received Amount -->

                    <q-item v-if="details.currency === 'IRT'">
                        <q-item-section avatar>
                            <q-btn dense flat size="md" color="primary"
                                   icon="far fa-copy" round
                                   v-clipboard="details.rate * 10"
                                   @success="copied('Recipient\'s receive amount is copied!')"
                                   :loading="loading"
                            />
                        </q-item-section>

                        <q-item-section v-if="loading">
                            <q-item-label>
                                <q-skeleton type="text"/>
                            </q-item-label>
                            <q-item-label caption>
                                <q-skeleton type="text"/>
                            </q-item-label>
                        </q-item-section>

                        <q-item-section v-else>
                            <q-item-label caption>Recipient's receive amount:</q-item-label>
                            <q-item-label lines="1">
                                <currency-format
                                    class="inline-block text-bold"
                                    :value="details.rate * 10"
                                    unit="ریال"
                                    hide-white-spaces
                                    hide-zero-decimal
                                />
                            </q-item-label>
                        </q-item-section>
                    </q-item> <!-- Received Rial Amount -->

                    <q-item>
                        <q-item-section avatar>
                            <q-btn dense flat size="md" color="primary"
                                   icon="far fa-copy" round
                                   v-clipboard="details.account_number.toString().replaceAll(' ', '')"
                                   @success="copied('Recipient\'s ' + details.account_type + ' is copied!')"
                                   :loading="loading"
                            />
                        </q-item-section>

                        <q-item-section v-if="loading">
                            <q-item-label>
                                <q-skeleton type="text"/>
                            </q-item-label>
                            <q-item-label caption>
                                <q-skeleton type="text"/>
                            </q-item-label>
                        </q-item-section>

                        <q-item-section v-else>
                            <q-item-label caption>{{ details.account_type }}:</q-item-label>
                            <q-item-label lines="1" class="text-bold">
                                {{ details.account_number }}
                            </q-item-label>
                        </q-item-section>
                    </q-item> <!-- Account Number -->

                    <q-item v-if="details.notes">
                        <q-item-section avatar>
                            <q-btn dense flat size="md" color="primary"
                                   icon="far fa-copy" round
                                   v-clipboard="details.notes.toString().replaceAll(' ', '')"
                                   @success="copied('Recipient\'s ' + details.notes_title + ' is copied!')"
                                   :loading="loading"
                            />
                        </q-item-section>

                        <q-item-section v-if="loading">
                            <q-item-label>
                                <q-skeleton type="text"/>
                            </q-item-label>
                            <q-item-label caption>
                                <q-skeleton type="text"/>
                            </q-item-label>
                        </q-item-section>

                        <q-item-section v-else>
                            <q-item-label caption>{{ details.notes_title }}:</q-item-label>
                            <q-item-label lines="1" class="text-bold">
                                {{ details.notes }}
                            </q-item-label>
                        </q-item-section>
                    </q-item> <!-- Note -->

                    <q-item v-if="details.bank_references">
                        <q-item-section avatar>
                            <q-btn dense flat size="md" color="primary"
                                   icon="far fa-copy" round
                                   v-clipboard="details.bank_references"
                                   @success="copied('Bank References copied!')"
                                   :loading="loading"
                            />
                        </q-item-section>

                        <q-item-section v-if="loading">
                            <q-item-label>
                                <q-skeleton type="text"/>
                            </q-item-label>
                            <q-item-label caption>
                                <q-skeleton type="text"/>
                            </q-item-label>
                        </q-item-section>

                        <q-item-section v-else>
                            <q-item-label caption>Bank References:</q-item-label>
                            <q-item-label lines="1" class="text-bold">
                                {{ details.bank_references }}
                            </q-item-label>
                        </q-item-section>
                    </q-item> <!-- Bank references -->
                </q-list>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn label="OK" color="primary" v-close-popup/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import Transfer from '../models/Transfer'

export default {
    name: "OutgoingDetailsModal",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        reference: {
            type: String,
            required: true
        }
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        },
        details_text() {
            return this.details.bank + '\n'
            + this.details.recipient_name + '\n'
            + this.details.rate.toString().commaSeparate() + ' ' + (this.details.currency === 'IRT' ? 'تومان' : this.details.currency) + '\n'
            + (this.details.currency === 'IRT' ? (this.details.rate * 10).toString().commaSeparate() + ' ریال' + '\n' : '')
            + this.details.account_number.toString().replaceAll(' ', '') + '\n'
            + (this.details.notes ? this.details.notes.toString().replaceAll(' ', '') + '\n' : '')
            + this.details.bank_references
        }
    },
    data: function () {
        return {
            loading: false,
            details: {
                type: '',
                bank: '',
                recipient_name: '',
                rate: 0,
                currency: '',
                account_type: '',
                account_number: '',
                notes_title: '',
                bank_references: ''
            }
        }
    },
    methods: {
        outgoingDetails() {
            this.loading = true
            Transfer.outgoingDetails(this.reference, (details) => {
                // we also set (or update) rowsNumber
                this.details = details
                this.loading = false
            }).catch(error => {
                this.$q.notify({
                    message: error.data.error,
                    color: 'negative',
                    icon: 'fa fa-exclamation-triangle'
                })
                this.loading = false
            })
        },
        copied(message) {
            this.$q.notify({
                message: message,
                position: 'top'
            })
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
        showModal(val) {
            if (val) {
                this.outgoingDetails()
            }
        }
    },
    components: {}
}
</script>

<style scoped>

</style>
